
import React from 'react';
import SlideShow from './SlideShow';
import './slideanimation.scss';
const MaterialPreview = (props) => {
    return (
        <>
         <SlideShow items={props.items[0]} animation={props.animation} />
        </>
    )
};
export default MaterialPreview;
